import { render, staticRenderFns } from "./appPanel.vue?vue&type=template&id=166142a6&"
import script from "./appPanel.vue?vue&type=script&lang=js&"
export * from "./appPanel.vue?vue&type=script&lang=js&"
import style0 from "./appPanel.vue?vue&type=style&index=0&id=166142a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports